var _path, _rect, _rect2, _rect3, _rect4, _path2, _path3, _path4, _rect5, _rect6, _rect7, _rect8, _path5, _path6, _path7, _rect9, _rect0, _rect1, _rect10, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultipleItemsSelectOneActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 124,
    viewBox: "0 0 164 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1C3.23858 1 1 3.23858 1 6V118C1 120.761 3.23857 123 6 123H158C160.761 123 163 120.761 163 118V6C163 3.23858 160.761 1 158 1H6Z",
    fill: "#F0F9F5",
    stroke: "#68C598",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.5,
    y: 95,
    width: 22,
    height: 7,
    rx: 3.5,
    fill: "#68C598"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 67.6973,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 76.4121,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 81.127,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5 22H16.5V57H51.5V22ZM49.9899 23.5742H18.0762V55.5117H49.9899V23.5742Z",
    fill: "#68C598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7717 46.3261L29.8369 35.9238L19.8369 50.9238H33.5533L33.5 51H47.5L40.5 41L36.7717 46.3261Z",
    fill: "#68C598"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5467 38.0108C44.7816 38.0108 46.5933 36.2175 46.5933 34.0054C46.5933 31.7933 44.7816 30 42.5467 30C40.3117 30 38.5 31.7933 38.5 34.0054C38.5 36.2175 40.3117 38.0108 42.5467 38.0108Z",
    fill: "#68C598"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69.5,
    y: 67.4297,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 69.5,
    y: 76.1445,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 80.8594,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 71.5,
    y: 95,
    width: 22,
    height: 7,
    rx: 3.5,
    fill: "#68C598"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.5 22H64.5V57H99.5V22ZM97.9899 23.5742H66.0762V55.5117H97.9899V23.5742Z",
    fill: "#68C598"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.7717 46.3261L77.8369 35.9238L67.8369 50.9238H81.5533L81.5 51H95.5L88.5 41L84.7717 46.3261Z",
    fill: "#68C598"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5467 38.0108C92.7816 38.0108 94.5933 36.2175 94.5933 34.0054C94.5933 31.7933 92.7816 30 90.5467 30C88.3117 30 86.5 31.7933 86.5 34.0054C86.5 36.2175 88.3117 38.0108 90.5467 38.0108Z",
    fill: "#68C598"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 68,
    width: 25,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 117.5,
    y: 76.7148,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 121.5,
    y: 81.4297,
    width: 17,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 118.5,
    y: 95,
    width: 22,
    height: 7,
    rx: 3.5,
    fill: "#68C598"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.5 22H112.5V57H147.5V22ZM145.99 23.5742H114.076V55.5117H145.99V23.5742Z",
    fill: "#68C598"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.772 46.3261L125.837 35.9238L115.837 50.9238H129.553L129.5 51H143.5L136.5 41L132.772 46.3261Z",
    fill: "#68C598"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.547 38.0108C140.782 38.0108 142.593 36.2175 142.593 34.0054C142.593 31.7933 140.782 30 138.547 30C136.312 30 134.5 31.7933 134.5 34.0054C134.5 36.2175 136.312 38.0108 138.547 38.0108Z",
    fill: "#68C598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleItemsSelectOneActive);
export default __webpack_public_path__ + "static/media/multiple-items-select-one-active.c3f7de0214b05ecb1707f7ff87120a10.svg";
export { ForwardRef as ReactComponent };